import React from 'react';
import { Info } from 'lucide-react';

interface FormFieldProps {
    id: string;
    label: string;
    required?: boolean;
    error?: string;
    hint?: string;
    children: React.ReactNode;
    className?: string;
}

const FormField: React.FC<FormFieldProps> = ({
    id,
    label,
    required = false,
    error,
    hint,
    children,
    className = ''
}) => {
    return (
        <div className={`form-field ${className}`}>
            <label htmlFor={id} className="block mb-2">
                <span className="text-gray-900 font-semibold text-base">
                    {label}
                    {!required && (
                        <span className="ml-2 text-sm text-gray-400 font-normal">
                            (optional)
                        </span>
                    )}
                </span>
            </label>

            {hint && (
                <div className="mb-3 flex items-start gap-2 text-sm text-gray-600">
                    <Info size={16} className="mt-0.5 flex-shrink-0" />
                    <span>{hint}</span>
                </div>
            )}

            {children}

            {error && (
                <div
                    id={`${id}-error`}
                    className="mt-2 text-sm text-red-600 flex items-start gap-1"
                    role="alert"
                >
                    <span className="mt-0.5">⚠️</span>
                    <span>{error}</span>
                </div>
            )}
        </div>
    );
};

export default FormField;
